import { CodeDiffEditor, CodeDiffEditorProps } from '~src/components/CodeEditor/CodeEditor';

type Props = Pick<CodeDiffEditorProps, 'modified' | 'original'>;

export function DiffEditor(props: Props) {
  return (
    <CodeDiffEditor
      keepCurrentModifiedModel={true}
      keepCurrentOriginalModel={true}
      language="json"
      options={{
        hideUnchangedRegions: {
          enabled: true,
        },
        minimap: {
          enabled: false,
        },
        renderOverviewRuler: false,
        renderIndicators: false,
        renderSideBySide: true,
        lineNumbers: 'off',
        readOnly: true,
      }}
      {...props}
    />
  );
}
